<template>
    <vReceiptComponent :postList="postList" v-if="flag"></vReceiptComponent>
</template>
<script>
import vReceiptComponent from '../../listComponent/basicdata/performance/receiptComponent.vue';
export default {
    name: 'receipt',
    components: {
        vReceiptComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>